import _ from "lodash";

export async function getCNDANotificationData(groupId) {

    const users = await global.app.C.CUser.find({
        fieldPath: ['kpUser.id'],
        group: new global.ObjectID(groupId)
    })

    const submitterFiles = await global.app.C.ReliefFund.find({
        query: {status: 'questioned'},
        fieldPath: ['submitter.id'],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    const controllerFiles = await global.app.C.ReliefFund.find({
        query: {status: {$in: ['ongoing', 'updated']}},
        fieldPath: ['id'],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    const validatorFiles = await global.app.C.ReliefFund.find({
        query: {status: 'controlled'},
        fieldPath: ['id'],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    const payerFiles = await global.app.C.ReliefFund.find({
        query: {status: 'accepted'},
        fieldPath: ['id',
            'totalAwardedAmountsInEuros', 'totalValidatedAmountsInEuros',
            'totalAwardedAmountsInKilograms', 'totalValidatedAmountsInKilograms',
            'payments.id', 'payments.status'
        ],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    return users.filter(cUser => !!_.get(cUser, 'kpUser.id')).reduce((acc, cUser) => ({
        [cUser.kpUser.id]: {
            'm-C-submission': submitterFiles.filter(file => file.submitter.id === cUser.kpUser.id).length,
            'm-C-study': controllerFiles.length,
            'm-C-decision': validatorFiles.length,
            'm-C-reliefFundPayment': payerFiles.length, //payerFiles.filter(file => file.totalAwardedAmountsInEuros > file.totalValidatedAmountsInEuros || file.totalAwardedAmountsInKilograms > file.totalValidatedAmountsInKilograms).length,
            'm-C-reliefFundPaymentValidation': payerFiles.flatMap(file => file.payments.filter(payment => payment.status.id === 'ongoing')).length
        },
        ...acc
    }), {})
}
